import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Title from '../../shared/Title';
import FFPaper from '../../shared/FFPaper';
import FFLinearProgress from '../../shared/FFLinearProgress';
import MultipleDropDownMenu from '../../shared/MultipleDropDownMenu';
import KebabMenu, { defaultMenus } from '../../shared/KebabMenu';
import { PercentageValues } from '../../../model/enrollment';
import { useTranslation } from 'react-i18next';

const handler = (menu: string) => {
    console.log(menu);
}

export interface EnrolledByGroupProps {
    data?: PercentageValues;
}


export default function EnrolledByGroupCard({ data }: EnrolledByGroupProps) {
    const { t } = useTranslation();

    return (
        <Grid item={true} xs={12} >
            <FFPaper
                sx={{
                    alignItems: 'stretch',
                    position: 'relative',
                    flexDirection: 'row',
                }}
            >
                <KebabMenu
                    menus={defaultMenus}
                    handler={handler}
                />

                <Grid item={true} xs={12} sx={{ display: 'flex', flexDirection: 'column', position: 'relative', pb: 3, pt: 1, pl: 0, pr: 0 }}>

                    <Stack direction="row" spacing={2} sx={{ pr: 7, pl: 2 }}>

                        <Title info={t('enroll_by_group_tooltip')}>{t('enroll_by_group_title')}</Title>

                        <Stack direction="row" spacing={2} sx={{ pr: 1, pb: 1, mb: 1, flex: '1 0 35%', alignItems: 'center' }}>
                            <Typography sx={{ fontSize: '12px', color: 'text.primary' }} >Last update 1 min ago</Typography>
                        </Stack>

                        <MultipleDropDownMenu multipleLabel='Groups' label="Groups" options={['VIP', 'Shoplifters', 'Fraudsters', 'Managers']} />

                    </Stack>

                    <Stack direction="column"
                        spacing={3}
                        sx={{
                            pr: 0,
                            pt: 3,
                            pl: 1,
                        }}>
                        {data && data.value.map(({ groupName, percentages }, i) => {
                            const percentageValue = Number(percentages.replace('%', ''));

                            return <Stack key={i} direction="row" spacing={2} sx={{ alignItems: 'center' }}>
                                <Typography color="secondary" fontSize={14} sx={{ flex: '1 0 15%', pl: 3 }}>{groupName}</Typography>
                                <FFLinearProgress percentage={true} indicator={true} progressValue={percentageValue} sx={{ flex: '1 0 70%', pl: 3 }} />
                                <Typography color="primary" fontSize={14} sx={{ flex: '1 0 15%', pl: 3 }}>{percentages}</Typography>
                            </Stack>
                        }
                        )}
                    </Stack>
                </Grid>
            </FFPaper>
        </Grid>
    )
}